"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IteroEventBus = void 0;
var eventInfo_1 = require("./eventInfo");
var eventSchema_service_1 = require("./eventSchema.service");
var timber_service_1 = require("./timber.service");
var itero_event_bus_1 = require("@itero/itero-event-bus");
var sharedSchemas_1 = require("./sharedSchemas");
__exportStar(require("./interfaces"), exports);
var IteroEventBus = /** @class */ (function () {
    /** @param loggingEndpoint - URL to send logs to, if logging is required otherwise error could be taken from results
     * @param instanceId - Unique identifier for the instance of the application.
     */
    function IteroEventBus(_a) {
        var _b = _a === void 0 ? {} : _a, loggingEndpoint = _b.loggingEndpoint, instanceId = _b.instanceId;
        this.validChannelName = ["platform-channel" /* ChannelNames.platformChannel */, "application-channel" /* ChannelNames.applicationChannel */];
        if (loggingEndpoint) {
            this.timberService = new timber_service_1.TimberService(loggingEndpoint);
        }
        if (instanceId) {
            this.instanceId = instanceId;
        }
        this.eventBus = new itero_event_bus_1.EventBus({ loggingEndpoint: loggingEndpoint, commonSectionSchemas: sharedSchemas_1.sharedSchemas });
    }
    /**
     * @deprecated Use `subscribe` method instead.
     */
    IteroEventBus.prototype.on = function (channelName, callbackAppId, callbackFunc) {
        return this.subscribe({ channelName: channelName, callbackAppId: callbackAppId, callbackFunc: callbackFunc }).success;
    };
    /**
     * Subscribes to an event on the specified channel.
     * @param params - An object containing the subscription parameters.
     * @param params.channelName - The name of the channel. Use '*' to subscribe to all channels.
     * @param params.callbackAppId - The ID of the application that will handle the event.
     * @param params.callbackFunc - The function to call when the event is triggered.
     * @returns {SubscriptionResult} The result of the subscription.
     */
    IteroEventBus.prototype.subscribe = function (_a) {
        var _b, _c;
        var channelName = _a.channelName, callbackAppId = _a.callbackAppId, callbackFunc = _a.callbackFunc;
        if (channelName === '*') {
            var result = this.eventBus.on("platform-channel" /* ChannelNames.platformChannel */, callbackAppId, callbackFunc);
            var resultAppChannel = this.eventBus.on("application-channel" /* ChannelNames.applicationChannel */, callbackAppId, callbackFunc);
            if (!resultAppChannel.success) {
                result.success = resultAppChannel.success;
                if (!result.success && result.error) {
                    result.error.message = "".concat((_b = result.error) === null || _b === void 0 ? void 0 : _b.message, " ").concat((_c = resultAppChannel.error) === null || _c === void 0 ? void 0 : _c.message);
                }
                else {
                    result.error = resultAppChannel.error;
                }
            }
            return result;
        }
        return this.eventBus.on(channelName, callbackAppId, callbackFunc);
    };
    /**
     * @deprecated Use `send` method instead.
     */
    IteroEventBus.prototype.emit = function (channelName, publisherAppId, eventName, eventId, targetApplications, eventPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var channelNameValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        channelNameValue = channelName = channelName;
                        return [4 /*yield*/, this.emitEvent({ channelName: channelNameValue, publisherAppId: publisherAppId, eventName: eventName, eventId: eventId, targetApplications: targetApplications, eventPayload: eventPayload })];
                    case 1: return [2 /*return*/, (_a.sent()).success];
                }
            });
        });
    };
    /**
     * Sends an event.
     * @param params - An object containing the event parameters.
     * @param params.publisherAppId - The ID of the application that publishes the event.
     * @param params.eventName - The name of the event.
     * @param params.targetApplications - The target applications for the event.
     * @param params.eventPayload - The payload of the event.
     * @returns {Promise<SendingResult>} The result of the sending operation.
     */
    IteroEventBus.prototype.send = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var channelName, eventId;
            var publisherAppId = _b.publisherAppId, eventName = _b.eventName, targetApplications = _b.targetApplications, eventPayload = _b.eventPayload;
            return __generator(this, function (_c) {
                channelName = eventInfo_1.PlatformChannelEvents.includes(eventName) ? "platform-channel" /* ChannelNames.platformChannel */ :
                    eventInfo_1.ApplicationChannelEvents.includes(eventName) ? "application-channel" /* ChannelNames.applicationChannel */ : '';
                eventId = this.generateEventId();
                return [2 /*return*/, this.emitEvent({ channelName: channelName, publisherAppId: publisherAppId, eventName: eventName, eventId: eventId, targetApplications: targetApplications, eventPayload: eventPayload })];
            });
        });
    };
    /**
     * Unsubscribes an application from a channel or all channels.
     * @param channelName - The name of the channel or '*' to unsubscribe from all channels.
     * @param appIdToUnsubscribe - The ID of the application to unsubscribe.
     */
    IteroEventBus.prototype.unsubscribe = function (channelName, appIdToUnsubscribe) {
        if (channelName === '*') {
            this.eventBus.unsubscribe("platform-channel" /* ChannelNames.platformChannel */, appIdToUnsubscribe);
            this.eventBus.unsubscribe("application-channel" /* ChannelNames.applicationChannel */, appIdToUnsubscribe);
        }
        else {
            this.eventBus.unsubscribe(channelName, appIdToUnsubscribe);
        }
    };
    IteroEventBus.prototype.generateEventId = function () {
        return this.eventBus.generateEventId();
    };
    IteroEventBus.prototype.setRegion = function (region) {
        this.eventBus.region = region;
    };
    IteroEventBus.prototype.getRegion = function () {
        return this.eventBus.region;
    };
    IteroEventBus.prototype.setSessionId = function (sessionId) {
        this.eventBus.sessionId = sessionId;
    };
    IteroEventBus.prototype.getSessionId = function () {
        return this.eventBus.sessionId;
    };
    IteroEventBus.prototype.emitEvent = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var logParams, result, eventSchemeExists, eventSchema, errorMessage;
            var _c;
            var channelName = _b.channelName, publisherAppId = _b.publisherAppId, eventName = _b.eventName, eventId = _b.eventId, targetApplications = _b.targetApplications, eventPayload = _b.eventPayload;
            return __generator(this, function (_d) {
                logParams = {
                    module: 'emit',
                    extendedParameters: { eventId: eventId, channelName: channelName, publisherAppId: publisherAppId, eventName: eventName, sessionId: this.eventBus.sessionId }
                };
                result = this.validateChannel(channelName, eventName, logParams, eventId);
                if (result.success) {
                    eventSchemeExists = eventSchema_service_1.EventSchemaService.Schemes.has(eventName);
                    if (eventSchemeExists) {
                        eventSchema = eventSchema_service_1.EventSchemaService.Schemes.get(eventName);
                        return [2 /*return*/, this.eventBus.emit(channelName, publisherAppId, eventName, eventSchema, eventId, targetApplications, eventPayload, this.instanceId)];
                    }
                    errorMessage = "Failed to found event schema for ".concat(eventName);
                    (_c = this.timberService) === null || _c === void 0 ? void 0 : _c.error(errorMessage, logParams);
                    result.error = new Error(errorMessage);
                    result.success = false;
                }
                return [2 /*return*/, result];
            });
        });
    };
    IteroEventBus.prototype.validateChannel = function (channelName, eventName, logParams, eventId) {
        var _a, _b;
        if (this.validChannelName.includes(channelName)) {
            if (channelName === "platform-channel" /* ChannelNames.platformChannel */) {
                if (eventInfo_1.PlatformChannelEvents.includes(eventName))
                    return { success: true, eventId: eventId };
            }
            else if (channelName === "application-channel" /* ChannelNames.applicationChannel */) {
                if (eventInfo_1.ApplicationChannelEvents.includes(eventName))
                    return { success: true, eventId: eventId };
            }
            var errorMessage_1 = "Channel ".concat(channelName, " is not supported with event ").concat(eventName);
            (_a = this.timberService) === null || _a === void 0 ? void 0 : _a.error(errorMessage_1, logParams);
            return { success: false, eventId: eventId, error: new Error(errorMessage_1) };
        }
        var errorMessage = "Channel ".concat(channelName ? channelName + ' ' : '', "is not supported for ").concat(eventName, " event.");
        (_b = this.timberService) === null || _b === void 0 ? void 0 : _b.error(errorMessage, logParams);
        return { success: false, eventId: eventId, error: new Error(errorMessage) };
    };
    return IteroEventBus;
}());
exports.IteroEventBus = IteroEventBus;
